import { makeAutoObservable } from "mobx";
import { AtticusClient } from "../api/atticus.api";

export class AuthStore {
	user : IAuthStore.ProfileProps | null = null;
	token: string | null = null;

	constructor(){
		makeAutoObservable(this);
	}

	setToken = (token: string | null): void => {
		this.token = token;
	}

	setUserProfile = (details: IAuthStore.ProfileProps | null) => {
		this.user = details;
	}

	updateToken = async (token: string | null): Promise<void> => {
		if (token) await localStorage.setItem("atticus-auth-token", token);
		else await localStorage.removeItem("atticus-auth-token");

		this.setToken(token);
	}

	getUserProfile = async () => await AtticusClient.GetProfile();
	
	loadUserProfile = async () => {
		const user = await this.getUserProfile();
		if(user){	
			this.setUserProfile(user);
		}
	}

	resetAuthentication = async () => {
		this.setUserProfile(null);
		this.updateToken(null);
	}
}

export default new AuthStore();